/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");
var R = require("ramda");


/**
 * Returns true if the unwrapped "this" contains the word "empty".
 */
/*function containsEmpty(this: MaybeObservable<string>): boolean {*/
function containsEmpty() {
    /*jshint validthis:true*/
    return ko.unwrap(this).indexOf("empty") >= 0;
}

//-------------------------------------------
// Ensures subscriptions are created using
// ko.toJS when "this._internalUpdate" is true.
// "targetFn" is always called.
function createInternalSubscription(name, targetFn) {
    var properties = name.split(".");
    return function internalEnsureSubscription() {
        var i, l, item = this;
        for (i = 0, l = properties.length; i < l; i += 1) {
            item = item[properties[i]];
            if (item === undefined) { break; }
        }
        if (this._internalUpdate) { ko.toJS(item); }
        return targetFn.apply(this, arguments);
    };
}

//-------------------------------------------
// Create a function that calls "targetFn"
// (preserving "this" context) and ensuring
// that "this._internalUpdate" will be
// true while "targetFn" is running (preventing
// execution of "_onObservableChanged").
function createInternalUpdateGuard(targetFn) {
    return function internalUpdateGuard() {
        if (this._internalUpdate) { return; }
        var originalValue = this._internalUpdate;
        this._internalUpdate = true;
        try {
            return targetFn.apply(this, arguments);
        } finally {
            this._internalUpdate = originalValue;
        }
    };
}

//-------------------------------------------
// Builds a list of functions to resolve paths specified,
// ending with a function that returns the `defaultValue`.
var getPathResolvers = R.compose(
        R.flatten, // flatten R.map and R.compose results into plain list of functions
        R.ap([
            R.compose(
                R.map(R.compose(R.path, R.split("."))), // create R.path call for every path in sequence
                R.filter(R.compose(R.identical("String"), R.type)), // filter non-stringy paths
                R.tail // treat tail as list of paths
            ),
            R.compose(R.always, R.head) // treat first element as defaultValue
        ]),
        R.of // transform arguments array to [arguments] for R.ap call input
    );

//-------------------------------------------
// Creates a function that will resolve the value using the paths supplied
// until a defined value of string type is found. If no value is found
// the defaultValue is returned. defaultValue is expected to be of string type.
//
// Example.
// var resolver = createResolverFunction("", "defaultValue", "viewModel.defaultValue", "viewModel.prototype.defaultValue");
// resolver({ defaultValue: "yep" }); // => "yep"
function createDefaultValueResolverFunction(defaultValue) {

    if (defaultValue === undefined) { throw new Error("defaultValue must be defined"); }
    if (typeof defaultValue !== "string") { throw new Error("defaultValue must be of string type"); }

    // Builds a function that executes each of the functions above until
    // a `defined` value is found.
    return R.compose(
        R.head,
        R.filter(R.compose(R.identical("String"), R.type)),
        R.ap(getPathResolvers(arguments)),
        R.of
    );
}

module.exports = {
    containsEmpty: containsEmpty,
    createInternalSubscription: createInternalSubscription,
    createInternalUpdateGuard: createInternalUpdateGuard,
    removeSurroundingWildcards: new RegExp("^\\*|\\*$", "g"),
    createDefaultValueResolverFunction: createDefaultValueResolverFunction
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/shared.js
// module id = 22
// module chunks = 49